import {useEffect, useRef, useState} from 'react';
import noAttend from '../../assets/icons/noAttend.svg';
import ModalContainer from '../modalContainer/index.jsx';
import NoAttendanceModal from '../noAttendanceModal';
import SignatureCanvas from '../signatureCanvas';
import {checkMeetingAttendanceWindow, saveBatchMeetingAttendance} from '../../API/apiService';

import './style.scss';
import {toast} from "react-toastify";

function UserAttendanceCard({data, meetingId, readOnly = false}) {
    // STATES //
    const [attended, setAttended] = useState(null);
    const [OpenModalAdd, setOpenModalAdd] = useState(false);
    const [openSignatureModal, setOpenSignatureModal] = useState(false);
    const [hasSignature, setHasSignature] = useState(false);
    const signatureRef = useRef(null);
    const [submitting, setSubmitting] = useState(false);
    const busy = useRef(false);

    async function withAttendanceWindow(action) {
        if (readOnly || busy.current) return;
        busy.current = true;
        setSubmitting(true);
        try {
            if (await checkMeetingAttendanceWindow(meetingId)) await action();
        } finally {
            busy.current = false;
            setSubmitting(false);
        }
    }

    const info = {
        title: 'Motivo inasistencia',
        argumentValue: 'Argumento',
        observations: 'Observaciones del mediador'
    };

    function updateValues(value) {
        if (!data.savedInMeeting) {
            setAttended(value);
            data.attended = value;
            if (value === false) {
                setOpenModalAdd(true);
            } else {
                data.argument = null;
                data.notes = null;
                data.image = null;
                data.base64 = null;
                data.withoutSignature = false;
            }
        }
    }

    function onAttendedButtonClick() {
        if (readOnly) {
            return;
        }
        withAttendanceWindow(() => {
            if (data.savedInMeeting) {
                toast('No puedes modificar la asistencia almacenada', {type: 'info'});
                return;
            }
            setHasSignature(false);
            setOpenSignatureModal(true);
        });
    }

    function confirmSignature() {
        if (!hasSignature || !signatureRef.current?.hasDrawn()) {
            toast('La persona debe firmar antes de confirmar su asistencia', {
                type: 'warning'
            });
            return;
        }

        const signature = signatureRef.current.toDataURL();
        if (!signature) {
            toast('No se pudo capturar la firma. Intente nuevamente', {
                type: 'error'
            });
            return;
        }

        withAttendanceWindow(async () => {
            const saved = await saveBatchMeetingAttendance({
                beneficiaryId: data.id,
                meetingIds: [meetingId],
                signature,
                notes: 'Firma registrada desde la lista del encuentro'
            });
            if (!saved) return;
            data.base64 = signature;
            data.image = null;
            data.argument = null;
            data.notes = null;
            data.withoutSignature = false;
            data.savedInMeeting = true;
            setAttended(true);
            data.attended = true;
            setOpenSignatureModal(false);
        });
    }

    function confirmWithoutSignature() {
        withAttendanceWindow(() => {
            data.base64 = null;
            data.image = null;
            data.argument = null;
            data.notes = null;
            data.withoutSignature = true;
            setAttended(true);
            data.attended = true;
            setHasSignature(false);
            signatureRef.current?.clear();
            setOpenSignatureModal(false);
        });
    }

    function updateAttendanceInfo(info) {
        data.attended = false;
        data.argument = info.argument;
        data.notes = info.notes;
        data.image = null;
        data.base64 = null;
        data.withoutSignature = false;
    }

    useEffect(() => {
        if (data?.attended !== undefined && data?.attended !== null) {
            setAttended(data.attended);
        }
    }, [data?.attended]);
    return (
        <>
            {OpenModalAdd && (
                <ModalContainer>
                    <NoAttendanceModal info={info} setOpenModalAdd={setOpenModalAdd}
                                       updateAttendanceInfo={updateAttendanceInfo}/>
                </ModalContainer>
            )}
            {openSignatureModal && (
                <ModalContainer>
                    <div className='attendance-signature-modal' role='dialog' aria-modal='true'
                         aria-labelledby={`signature-title-${data?.id}`}>
                        <button type='button' className='attendance-signature-modal__close'
                                disabled={submitting}
                                aria-label='Cerrar firma'
                                onClick={() => setOpenSignatureModal(false)}>
                            <span className='material-symbols-rounded'>close</span>
                        </button>
                        <h2 id={`signature-title-${data?.id}`}>Firma de asistencia</h2>
                        <p className='attendance-signature-modal__name'>{data?.full_name}</p>
                        <p className='attendance-signature-modal__description'>
                            Firme en el recuadro o registre la asistencia sin firma.
                        </p>
                        <SignatureCanvas
                            ref={signatureRef}
                            height={200}
                            onDrawChange={setHasSignature}
                        />
                        <p>La firma se guarda al confirmar la asistencia.</p>
                        <div className='attendance-signature-modal__actions'>
                            <button type='button' className='attendance-signature-modal__cancel'
                                    disabled={submitting}
                                    onClick={() => setOpenSignatureModal(false)}>
                                Cancelar
                            </button>
                            <button type='button' className='attendance-signature-modal__without-signature'
                                    disabled={submitting}
                                    onClick={confirmWithoutSignature}>
                                Sin firma
                            </button>
                            <button type='button' className='attendance-signature-modal__confirm'
                                    disabled={!hasSignature || submitting} onClick={confirmSignature}>
                                Confirmar asistencia
                            </button>
                        </div>
                    </div>
                </ModalContainer>
            )}
            <div className='user-container'>
                <h2 className='name'>{data?.full_name}</h2>
                <div className='buttons-container'>
                    <button
                        aria-label='Asistió'
                        onClick={onAttendedButtonClick}
                        disabled={readOnly || submitting}
                        className={`attended 
                        ${attended === null || attended === undefined || attended === false ?
                            'attended--false' : ''
                        }`}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='21'
                            className='svg'
                            height='16.747'
                            viewBox='0 0 21 16.747'>
                            <path
                                id='how_to_reg_FILL0_wght400_GRAD0_opsz48'
                                d='M4,25.228V22.76a3.144,3.144,0,0,1,.446-1.641,2.836,2.836,0,0,1,1.339-1.142A19.623,19.623,0,0,1,9.25,18.77,13.822,13.822,0,0,1,12.4,18.4a15.11,15.11,0,0,1,1.614.092,11.731,11.731,0,0,1,1.746.328l-1.286,1.286q-.525-.052-1.037-.092T12.4,19.977a12.854,12.854,0,0,0-2.769.276A18.217,18.217,0,0,0,6.415,21.4a1.314,1.314,0,0,0-.643.6,1.7,1.7,0,0,0-.2.761v.893h8.374l1.575,1.575Zm14.306.42-3.7-3.7,1.1-1.1,2.6,2.6L23.9,17.851l1.1,1.1ZM12.4,16.775a3.776,3.776,0,0,1-3.937-3.937A3.776,3.776,0,0,1,12.4,8.9a3.776,3.776,0,0,1,3.938,3.937A3.776,3.776,0,0,1,12.4,16.775ZM13.949,23.653ZM12.4,15.2a2.289,2.289,0,0,0,2.362-2.362A2.289,2.289,0,0,0,12.4,10.475a2.289,2.289,0,0,0-2.363,2.363A2.289,2.289,0,0,0,12.4,15.2ZM12.4,12.837Z'
                                transform='translate(-4 -8.9)'
                                fill='#FFFFFF'
                            />
                        </svg>
                    </button>
                    <button
                        aria-label='No asistió'
                        onClick={() => {
                            if (readOnly) return;
                            updateValues(false);
                        }}
                        disabled={readOnly || submitting}
                        className={`
                        ${attended === null || attended === undefined || attended === true ?
                            'not-attend' : 'not-attend not-attend--false'
                        }`}>
                        <img src={noAttend} alt=''/>
                    </button>
                    {attended === null || attended === undefined ? (
                        <p></p>
                    ) : (
                        attended === true ? (
                            <>
                                <p className='attended-text'>
                                    {data?.withoutSignature || (!data?.base64 && !data?.image && !data?.imageId)
                                        ? 'Asistió sin firma'
                                        : 'Asistió'}
                                </p>
                            </>
                        ) : (
                            <p className='no-attend'>No asistio</p>
                        )
                    )}
                </div>
            </div>
        </>
    );
}

export default UserAttendanceCard;

